@if (isMenu) {
  @if (showButton) {
    <button mat-menu-item>
      <mat-icon>reply</mat-icon>
      {{ 'reply' | translate }}
    </button>
  }
} @else {
  <app-loading-icon-button
    label="reply"
    icon="reply"
    [showButton]="showButton"
    [disabled]="disabled"
    [showLoading]="showLoading"></app-loading-icon-button>
}
